/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { SepaExportDebitorDetailRequest, SepaExportDebitorDetailResponse } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class SepaExportDebitorDetailController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags sepa-export-debitor-detail-controller
   * @name UpdateSepaExportDebitorDetailDefaultFlag
   * @request PUT:/api/v1/payment-details/accounts-payable/sepa/debitor/{sepaExportDebitorDetailEntry}/default
   */
  updateSepaExportDebitorDetailDefaultFlag = (
    sepaExportDebitorDetailEntry: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/payment-details/accounts-payable/sepa/debitor/${sepaExportDebitorDetailEntry}/default`,
      method: 'PUT',
      ...params,
    })

  static updateSepaExportDebitorDetailDefaultFlagPath =
    '/v1/payment-details/accounts-payable/sepa/debitor/${sepaExportDebitorDetailEntry}/default'
  static updateSepaExportDebitorDetailDefaultFlagMethod = 'PUT'
  /**
   * No description
   *
   * @tags sepa-export-debitor-detail-controller
   * @name GetAllSepaExportDebitorDetails
   * @request GET:/api/v1/payment-details/accounts-payable/sepa/debitor
   */
  getAllSepaExportDebitorDetails = (params: RequestParams = {}) =>
    this.http.request<SepaExportDebitorDetailResponse[], any>({
      path: `/v1/payment-details/accounts-payable/sepa/debitor`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAllSepaExportDebitorDetailsPath = '/v1/payment-details/accounts-payable/sepa/debitor'
  static getAllSepaExportDebitorDetailsMethod = 'GET'
  /**
   * No description
   *
   * @tags sepa-export-debitor-detail-controller
   * @name CreateSepaExportDebitorDetail
   * @request POST:/api/v1/payment-details/accounts-payable/sepa/debitor
   */
  createSepaExportDebitorDetail = (
    data: SepaExportDebitorDetailRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SepaExportDebitorDetailResponse, any>({
      path: `/v1/payment-details/accounts-payable/sepa/debitor`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createSepaExportDebitorDetailPath = '/v1/payment-details/accounts-payable/sepa/debitor'
  static createSepaExportDebitorDetailMethod = 'POST'
  /**
   * No description
   *
   * @tags sepa-export-debitor-detail-controller
   * @name DeleteSepaExportDebitorDetail
   * @request DELETE:/api/v1/payment-details/accounts-payable/sepa/debitor/{sepaExportDebitorDetailEntry}
   */
  deleteSepaExportDebitorDetail = (
    sepaExportDebitorDetailEntry: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/payment-details/accounts-payable/sepa/debitor/${sepaExportDebitorDetailEntry}`,
      method: 'DELETE',
      ...params,
    })

  static deleteSepaExportDebitorDetailPath =
    '/v1/payment-details/accounts-payable/sepa/debitor/${sepaExportDebitorDetailEntry}'
  static deleteSepaExportDebitorDetailMethod = 'DELETE'
}
